import { normalizeFlow } from "./identity";

/** Canonical PostHog event names. Keep in sync with add-posthog-to-flow/reference.md (no KYC). */
export function createEvents(flowInput?: string | null) {
  const flow = normalizeFlow(flowInput);
  return {
    LINK_OPENED: `ux.${flow}.loading.link.opened`,
    TERMS_ACCEPTED: `ux.${flow}.welcome.terms.created`,
    ACCEPT_BUTTON_CLICK: `ui.${flow}.welcome.accept_button.click`,
    DESTINATION_SELECTED: `ui.${flow}.route_amount.destination_country.select`,
    ORIGIN_SELECTED: `ui.${flow}.route_amount.origin_country.select`,
    AMOUNT_SUBMITTED: `ui.${flow}.route_amount.amount_input.submit`,
    PRE_QUOTE_CREATED: `ux.${flow}.route_amount.pre_quote.created`,
    ROUTE_DETECTED: `ux.${flow}.route_amount.route.detected`,
    FUNDING_SELECTED: `ui.${flow}.funding.method_chip.select`,
    PAYOUT_SELECTED: `ui.${flow}.payout.method_chip.select`,
    INTENT_SELECTED: `ui.${flow}.intent.intent_chip.select`,
    RECIPIENT_NAME_SUBMIT: `ux.${flow}.recipient.name.submit`,
    CAPABILITY_SELECTED: `ux.${flow}.payout_details.capability.select`,
    CARD_REGISTERED: `ux.${flow}.funding_data.card.registered`,
    QUOTE_CREATED: `ux.${flow}.summary.quote.created`,
    CONTINUE_CLICK: `ui.${flow}.summary.continue_button.click`,
    OPERATION_CREATED: `ux.${flow}.committing.operation.created`,
    REQUEST_CREATED: `ux.${flow}.committing.request.created`,
    OPERATION_STATUS_CHANGED: `ux.${flow}.home.operation.status_changed`,
    REQUEST_STATUS_CHANGED: `ux.${flow}.home.request.status_changed`,
    MERCHANT_SELECTED: `ui.${flow}.merchant_picker.merchant_item.select`,
    BARCODE_CREATED: `ux.${flow}.barcode.funding_barcode.created`,
    ERROR_SCREEN: `ui.${flow}.error.screen.view`,
    SESSION_EXPIRED: `ui.${flow}.session_expired.screen.view`,
    SERVICE_UNAVAILABLE: `ui.${flow}.service_unavailable.screen.view`,
    SUPPORT_VIEW: `ui.${flow}.support.screen.view`,
    LEGAL_VIEW: `ui.${flow}.legal.screen.view`,
    LANDING_VIEW: `ui.${flow}.landing.screen.view`,
    ADD_CARD_VIEW: `ui.${flow}.funding_data.screen.view`,
    BILLING_VIEW: `ui.${flow}.billing_address.screen.view`,
    ADD_CARD_PROCESSING_VIEW: `ui.${flow}.add_card_processing.screen.view`,
    CASH_DEPOSIT_LAUNCH: `ui.${flow}.home.cash_deposit_button.click`,
    SHARE_CLICK: `ui.${flow}.done.share_button.click`,
    EXIT_CLICK: `ui.${flow}.error.exit_button.click`,
    OFAC_VIEW: `ui.${flow}.ofac.screen.view`,
    OFAC_SUBMIT: `ux.${flow}.ofac.screening.submitted`,
    CLAIM_ENTRY_VIEW: `ui.${flow}.claim_entry.screen.view`,
    CLAIM_BLOCKED_VIEW: `ui.${flow}.claim_blocked.screen.view`,
    FUND_REQUEST_ENTRY_VIEW: `ui.${flow}.fund_request.screen.view`,
    FUND_REQUEST_PAY_CLICK: `ui.${flow}.fund_request.pay_button.click`,
    REQUEST_FULFILLED_VIEW: `ui.${flow}.request_already_fulfilled.screen.view`,
    COMMIT_ERROR_VIEW: `ui.${flow}.commit_error.screen.view`,
    SMS_CONSENT_VIEW: `ui.${flow}.sms_consent.popup.view`,
    SMS_CONSENT_POLICY_CLICK: `ui.${flow}.sms_consent.policy_link.click`,
    SMS_CONSENT_DECIDED: `ux.${flow}.sms_consent.decision.created`,
    SCREEN_VIEW: (screen: string) => `ui.${flow}.${screen}.screen.view`,
  } as const;
}

/** Default events for this widget's primary intent (overridden after claim via getEvents). */
export const Events = createEvents("request");

let activeEvents = Events;

export function setAnalyticsFlow(flow: string | undefined | null): void {
  activeEvents = createEvents(flow);
}

export function getEvents(): ReturnType<typeof createEvents> {
  return activeEvents;
}
